import { store } from "@betacrew/jars-flux";
import { PAGE_STATE } from "../../constants/constants";

export const componentKey = "DATA_LOADER";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        updateDataLoadingState: (state, action) => {
            state.dataLoadingState = action.payload;
        },
        setCountriesList: (state, action) => {
            state.countriesList = action.payload;
        },
        setStatesList: (state, action) => {
            state.statesList = action.payload;
        },
        setPrepayAmount: (state, action) => {
            state.prepayAmount = action.payload;
        },
        setIsPrepayAmountFetched: (state, action) => {
            state.isPrepayAmountFetched = action.payload;
        },
        setPermissions: (state, action) => {
            state.permissions = action.payload;
        },
        setGlobalFormsNYearsList: (state, action) => {
            state.globalFormsNYearsList = action.payload;
        },
        setforms94xList: (state, action) => {
            state.forms94xList = action.payload;
        }, 
        setFormCategory: (state, action) => {
            state.formCategory = action.payload;
        },
        setFormsScheduleDates: (state, action) => {
            state.formsScheduleDates = action.payload;
        },
        setBackEndConfigSettings: (state, action) => {
            state.backEndConfigSettings = action.payload;
        },
    },
    initialReducerState: {
        dataLoadingState: { state: PAGE_STATE.PRE_LOADING, message: "" },
        countriesList: [],
        statesList: [],
        prepayAmount: 0,
        isPrepayAmountFetched: false,
        permissions: {},
        forms94xList: {},
        formCategory:[],
        globalFormsNYearsList: {
            Forms: {},
            Years: {},
        },
        formsScheduleDates: {},
        backEndConfigSettings: {},
    },
})

export const {
    updateDataLoadingState,
    setCountriesList,
    setStatesList,
    setPrepayAmount,
    setIsPrepayAmountFetched,
    setPermissions,
    setGlobalFormsNYearsList,
    setforms94xList,
    setFormCategory,
    setFormsScheduleDates,
    setBackEndConfigSettings
} = actions;